<p-dialog styleClass="notes" [closable]="false" [(visible)]="displayNotesAdd" [modal]="true"
    [style]="{width: '55%', minWidth: '55%'}" appendTo="body">
    <p-header>
        <h5 class="p-d-inline-block p-mb-0">New Note</h5>
        <div class="pull-right p-text-right">
            <button pButton [icon]="icon" class="p-button-text p-button-rounded" (click)="pin()"></button>
        </div>
    </p-header>
    <form #createNote="ngForm" (ngSubmit)="addNote()">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <label>Comments</label>
                <!-- <p-editor id="comment" rows="5" cols="100" #comment="ngModel" required="true" placeholder="Enter Comment"
                    [mention]="usersList" [mentionConfig]="{labelKey:'name', returnTrigger:true, mentionSelect: onMentionSelect}"
                    [(ngModel)]="notesTemp.note.comment" (ngModelChange)="formatTexting()"
                    [ngClass]="{ 'p-invalid': comment.invalid && (comment.touched || comment.dirty) }" [ngModelOptions]="{standalone: true}" >
                </p-editor> -->
                <textarea required="true" rows="5" cols="100" [(ngModel)]="notesTemp.note.comment"
                    placeholder="Enter Comment" pInputTextarea id="comment" name="comment"
                    [ngClass]="{ 'p-invalid': comment.invalid && (comment.touched || comment.dirty) }"
                    #comment="ngModel" required="true">
                </textarea>
                <small class="p-invalid" *ngIf="comment.invalid && (comment.touched || comment.dirty)">Comment is
                    required</small>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12">
                <label>
                    Attachments
                    <i class="pi pi-exclamation-circle" [escape]="false" [pTooltip]="multiLineTooltip"
                        tooltipPosition="top"></i>
                </label>
                <p-fileUpload #fileUpload customUpload="true" mode="basic" chooseLabel="Choose"
                    [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
                    (onSelect)="uploadAttachments($event.files, fileUpload)"></p-fileUpload>
                <ng-container *ngIf="notesTemp.note.noteAttachments && (notesTemp.note.noteAttachments.length > 0)">
                    <app-lion-attachment-chips [attachments]="notesTemp.note.noteAttachments"
                        (removeAttachment)="removeAttachment($event)"></app-lion-attachment-chips>
                </ng-container>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton label="Cancel" (click)="cancel()" class="p-button-secondary"></button>
        <button pButton label="Save" [disabled]="disabledSubmit" (click)="createNote.ngSubmit.emit()"></button>
    </ng-template>
</p-dialog>

<!-- (onTextChange)="checkValue($event, comment)" -->
